import { type ButtonHTMLAttributes } from "react";
import { useTranslations } from "use-intl";
import { XIcon } from "@phosphor-icons/react";

type Props = Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "onClick" | "aria-label"
>;

export function ResetButton({ "aria-label": ariaLabel, onClick }: Props) {
  const t = useTranslations();

  return (
    <button
      type="button"
      className="shrink-0 cursor-pointer text-text-placeholder"
      aria-label={ariaLabel || t("flights.search.reset")}
      onClick={onClick}
    >
      <XIcon size={20} aria-hidden />
    </button>
  );
}
